import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const DependencyManagementSpork = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dependency-management-spork.title"
                    defaultMessage="Dependencies"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dependency-management-spork.bodyOne"
                    defaultMessage="Dependencies show the relationship between issues in a project or plan. Dependencies within a single team or project can be visualized in the timeline view of a project."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dependency-management-spork.bodyTwo"
                    defaultMessage="Dependencies across multiple teams and projects can be visualized in a plan using the pre-configured dependency management view or Dependencies tab."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dependency-management-spork.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about dependency management."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/guides/advanced-roadmaps/overview#how-do-i-manage-dependencies"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default DependencyManagementSpork;
